export const contactDialogTypes = ["bps", "decarbonize", "support"] as const

export type ContactDialogType = (typeof contactDialogTypes)[number]

export interface ContactDialogProps {
  onClose: () => void
  open: boolean
  type: ContactDialogType
}
